import firebase from "firebase/app";
import "firebase/auth";

import { AppThunk } from "services/redux/rootReducer";
import { LoginCredentials } from "features/auth/types/credentials";

const loginUser = (
    params: LoginCredentials
): AppThunk<Promise<firebase.auth.UserCredential>> => () => {
    const loginPromise = firebase
        .auth()
        .signInWithEmailAndPassword(params.email, params.password);

    return loginPromise;
};

export default loginUser;
